import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { fetchAllPostsAction } from '../store/actions/PostActions';
import Loader from '../components/Loader';
import moment from 'moment';

const Blog = () => {

  const { page } = useParams();
  const { loading } = useSelector(state => state.PostReducer);
  const { count, posts, perPage } = useSelector(state => state.FetchAllPostsReducer);
  const dispatch = useDispatch();
  
  useEffect(() => {
    dispatch(fetchAllPostsAction(page));
  }, []);
    
  return (
    <div className="blogs-section">
        <section className="primary-section">
            <div className="content">
                <h1 className="primary-heading">
                    <span><i class="fa fa-sun-o me-3"></i>Weather</span> Blogs
                </h1>
                <p className="description">
                    Explore latest weather updates from our community !!
                </p>
            </div>
        </section>
        <section className="blogs-container">
            {
                !loading ? posts.length > 0 ? 
                posts.map((post, index) => (
                    <Link to={`/details/${post.slug}`} className="box" key={index}>
                        <div className="content">
                            <div className="author">
                                <img src={post.user.profilePicture} alt="" />
                                <div className="name-date">
                                    <div className="name">{post.user.firstName + " " + post.user.lastName}</div>
                                    <div className="date">{moment(post.updatedAt).format("MMM Do YYYY")}</div>
                                </div>
                            </div>
                            <div className="body">
                                <h1 className="title">{post.title}</h1>
                                <div className="desc">{post.description.slice(0, 300)}</div>
                            </div>
                        </div>
                        <div className="image">
                            <img src={post.image} alt="" />
                        </div>
                    </Link>
                ))
                 : "Don't have posts !" : <Loader />
            }
        </section>
    </div>
  )
}

export default Blog;